import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import "./ManualUpi.scss";

const DynamicUpi = ({
  grandTotal,
  upiLink,
  table,
  onPaymentSubmit,
  verifying,
}) => {
  if (!upiLink) return null;

  return (
    <div className="section-card upi-box">
      <div className="qr-container">
        <h3>Scan & Pay</h3>
        <QRCodeCanvas
          value={upiLink}
          size={220}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H" // High error correction for better scanning
          includeMargin={true}
        />
      </div>

      <div className="payment-details">
        <p className="upi-note">
          <strong>Amount: ₹{grandTotal}</strong> • Table {table}
          <br />
          <span className="warning-text">
            ⚠️ Please complete payment in your app before confirming.
          </span>
        </p>
      </div>

      <div className="action-buttons">
        {/* Deep link for Mobile Users */}
        <a
          href={upiLink}
          className={`pay-btn secondary ${verifying ? "disabled" : ""}`}
          style={{
            textDecoration: "none",
            display: "block",
            marginBottom: "10px",
          }}
        >
          Open UPI App
        </a>

        {/* Confirmation Button */}
        <button
          className={`pay-btn primary ${verifying ? "loading" : ""}`}
          onClick={onPaymentSubmit}
          disabled={verifying}
        >
          {verifying ? "Verifying Payment..." : "I have completed payment"}
        </button>
      </div>
    </div>
  );
};

export default DynamicUpi;
